/**
 * Created by mgoria on 1/19/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RumSqsDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

var _AbstractDriver2 = require('./AbstractDriver');

var _FailedToSendSqsMessageException = require('./Exception/FailedToSendSqsMessageException');

var _FailedToSendBatchSqsMessageException = require('./Exception/FailedToSendBatchSqsMessageException');

var _FailedToReceiveSqsMessageException = require('./Exception/FailedToReceiveSqsMessageException');

var _FailedToDeleteSqsMessagesException = require('./Exception/FailedToDeleteSqsMessagesException');

var _InvalidSqsQueueUrlException = require('./Exception/InvalidSqsQueueUrlException');

var _RumEventValidationException = require('./Exception/RumEventValidationException');

var _EventFactory = require('./RUM/EventFactory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * SQS logging driver
 */
let RumSqsDriver = exports.RumSqsDriver = function (_AbstractDriver) {
  _inherits(RumSqsDriver, _AbstractDriver);

  /**
   * @param {String} queueUrl
   * @param {Object} kernel
   * @param {Boolean} enabled
   */
  function RumSqsDriver(queueUrl, kernel) {
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, RumSqsDriver);

    var _this = _possibleConstructorReturn(this, (RumSqsDriver.__proto__ || Object.getPrototypeOf(RumSqsDriver)).call(this));

    _this._queueUrl = queueUrl;
    _this._kernel = kernel;
    _this._enabled = enabled;

    _this._messagesBatch = [];
    _this._runningBatches = 0;
    _this._sqs = null;
    return _this;
  }

  /**
   * @returns {Number}
   */


  _createClass(RumSqsDriver, [{
    key: 'log',


    /**
     * @param {Object} message
     * @param {Function} callback
     */
    value: function log(message, callback) {
      if (!this.enabled) {
        callback(null, null);
        return;
      }

      let event = _EventFactory.EventFactory.create(this.kernel, message);

      // @todo - check message size, max is 256 KB (262,144 bytes)
      if (!event.isValid()) {
        callback(new _RumEventValidationException.RumEventValidationException(event.getEventLevel(), event.validationError), null);
        return;
      }

      if (this.kernel.isBackend) {
        if (this._messagesBatch.length < RumSqsDriver.BATCH_SIZE) {
          this._messagesBatch.push(event);
        }

        if (this._messagesBatch.length === RumSqsDriver.BATCH_SIZE) {
          let batch = this._messagesBatch.slice();
          this._messagesBatch = [];

          this._sendMessageBatch(batch, callback);
        } else {
          callback(null, null);
        }
      } else {
        this._sendMessage(event, callback);
      }
    }

    /**
     * @param {Function} callback
     */

  }, {
    key: 'flush',
    value: function flush(callback) {
      if (!this.enabled || this._messagesBatch.length === 0 && this._runningBatches === 0) {
        callback(null, null);
        return;
      }

      this._sendMessageBatch(this._messagesBatch, (error, data) => {
        this._messagesBatch = [];

        if (this._runningBatches > 0) {
          // wait for all batches to be pushed into SQS
          var intervalID = setInterval(() => {
            if (this._runningBatches === 0) {
              clearInterval(intervalID);
              return callback(error, data);
            }
          }, 50);
        } else {
          callback(error, data);
        }
      });
    }

    /**
     * @param {AbstractEvent} event
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_sendMessage',
    value: function _sendMessage(event, callback) {
      let params = {
        MessageBody: JSON.stringify(event),
        QueueUrl: this.queueUrl
      };

      this.sqs.sendMessage(params, (error, data) => {
        if (error) {
          error = new _FailedToSendSqsMessageException.FailedToSendSqsMessageException(params.QueueUrl, params.MessageBody, error);
        }

        callback(error, data);
      });
    }

    /**
     * @param {Array} messages
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_sendMessageBatch',
    value: function _sendMessageBatch(messages, callback) {
      if (messages.length === 0) {
        callback(null, null);
        return;
      }

      this._runningBatches++;

      let entries = [];
      messages.forEach((event, index) => {
        event = JSON.stringify(event);
        let id = `${_AbstractDriver2.AbstractDriver._md5(event)}-${new Date().getTime()}-${index}`;

        entries.push({
          Id: id,
          MessageBody: event
        });
      });

      var params = {
        QueueUrl: this.queueUrl,
        Entries: entries
      };

      this.sqs.sendMessageBatch(params, (error, data) => {
        this._runningBatches--;

        if (error) {
          error = new _FailedToSendBatchSqsMessageException.FailedToSendBatchSqsMessageException(params.QueueUrl, error);
        }

        callback(error, data);
      });
    }

    /**
     * @param {Function} callback
     */

  }, {
    key: 'receiveMessages',
    value: function receiveMessages(callback) {
      let params = {
        QueueUrl: this.queueUrl,
        MaxNumberOfMessages: 10,
        VisibilityTimeout: 20,
        WaitTimeSeconds: 0
      };

      this.sqs.receiveMessage(params, (error, data) => {
        if (error) {
          error = new _FailedToReceiveSqsMessageException.FailedToReceiveSqsMessageException(params.QueueUrl, error);
        }

        callback(error, data);
      });
    }

    /**
     * @param {Array} messages
     * @param {Function} callback
     */

  }, {
    key: 'deleteMessages',
    value: function deleteMessages(messages, callback) {
      if (messages.length === 0) {
        callback(null, null);
        return;
      }

      let params = {
        QueueUrl: this.queueUrl,
        Entries: []
      };

      messages.forEach(message => {
        params.Entries.push({
          Id: message.MessageId,
          ReceiptHandle: message.ReceiptHandle
        });
      });

      this.sqs.deleteMessageBatch(params, (error, data) => {
        if (error) {
          error = new _FailedToDeleteSqsMessagesException.FailedToDeleteSqsMessagesException(params.QueueUrl, error);
        }

        callback(error, data);
      });
    }

    /**
     * @param {Function} callback
     * @param {Object[]} additionalAttributes
     */

  }, {
    key: 'getQueueAttributes',
    value: function getQueueAttributes(callback) {
      let additionalAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      let defaultAttributes = ['ApproximateNumberOfMessages', 'ApproximateNumberOfMessagesNotVisible', 'ApproximateNumberOfMessagesDelayed'];

      let attributes = defaultAttributes.concat(additionalAttributes.filter(attr => defaultAttributes.indexOf(attr) === -1));

      let params = {
        QueueUrl: this.queueUrl,
        AttributeNames: attributes
      };

      this.sqs.getQueueAttributes(params, callback);
    }

    /**
     * @param {String} queueUrl
     * @returns {String}
     */

  }, {
    key: 'queueUrl',


    /**
     * @returns {String}
     */
    get: function get() {
      return this._queueUrl;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'kernel',
    get: function get() {
      return this._kernel;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'enabled',
    get: function get() {
      return this._enabled;
    }

    /**
     * @returns {AWS.SQS}
     */

  }, {
    key: 'sqs',
    get: function get() {
      if (!this._sqs) {
        this._sqs = new _awsSdk2.default.SQS({
          region: RumSqsDriver.getRegionFromSqsQueueUrl(this.queueUrl)
        });
      }

      return this._sqs;
    }
  }], [{
    key: 'getRegionFromSqsQueueUrl',
    value: function getRegionFromSqsQueueUrl(queueUrl) {
      let regionParts = queueUrl.match(/\.([^\.]+)\.amazonaws\.com\/.*/i);

      if (!regionParts || regionParts.length === 0) {
        throw new _InvalidSqsQueueUrlException.InvalidSqsQueueUrlException(queueUrl, 'Unable to extract AWS region.');
      }

      return regionParts[1];
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'BATCH_SIZE',
    get: function get() {
      return 10;
    }
  }, {
    key: 'ES_LOGS_INDEX',
    get: function get() {
      return 'rum';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'ES_LOGS_TYPE',
    get: function get() {
      return 'logs';
    }
  }]);

  return RumSqsDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/RumSqsDriver.js
// module id = 410
// module chunks = 0